import React, { useState } from "react"
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Row,
    Col,
} from "reactstrap"
import classnames from "classnames"

import { TableTopHeading } from "components/TableTopHeading"
import InventoryRequestIcon from "assets/images/warehouse/inventory-request/wh-rm-header-icon.png"
import InventoryReqWarehouseTheftListing from "./InventoryReq-Warehouse-TheftListing"
import InventoryReqDepartmentTheftListing from "./InventoryReq-Department-TheftListing"
import TheftIcon from "assets/images/icons/theft-icon.png"

const InventoryReqTheft = ({}) => {
    const [activeTabSecond, setActiveTabSecond] = useState("ic1")

    const toggle = tab => {
        if (activeTabSecond !== tab) {
            setActiveTabSecond(tab)
        }
    }

    let tabsConfig = [
        {
            title: "Warehouse",
            identifier: "ic1",
            content: <InventoryReqWarehouseTheftListing />,
        },
        {
            title: "Station",
            identifier: "ic2",
            content: <InventoryReqDepartmentTheftListing />,
        },
    ]
    return (
        <>
            <div className={"warehouse-nav-tabs"}>
                <TableTopHeading
                    title="Theft"
                    iconImage={TheftIcon}
                    iconClass={"inventory-req-icon"}
                    className="mb-3"
                />

                <>
                    <Nav tabs className="border-0">
                        {tabsConfig &&
                            tabsConfig.map(el => {
                                return (
                                    <NavItem key={el.identifier}>
                                        <NavLink
                                            className={classnames({
                                                active:
                                                    activeTabSecond ===
                                                    el.identifier,
                                            })}
                                            onClick={() => {
                                                toggle(el.identifier)
                                            }}
                                        >
                                            {el.title}
                                        </NavLink>
                                    </NavItem>
                                )
                            })}
                    </Nav>
                    <TabContent activeTab={activeTabSecond}>
                        {tabsConfig &&
                            tabsConfig.map(el => {
                                return (
                                    <TabPane
                                        tabId={el.identifier}
                                        key={el.identifier}
                                    >
                                        <Row>
                                            <Col sm="12">
                                                {activeTabSecond ==
                                                    el.identifier && el.content}
                                            </Col>
                                        </Row>
                                    </TabPane>
                                )
                            })}
                    </TabContent>
                </>
            </div>
        </>
    )
}

export default InventoryReqTheft
